export default ".system-update img {\n  height: 100vh;\n  float: right;\n}";